import { KeyboardEvent, RefObject } from 'react'

export const waitForElement = async (
  id: string,
  timeoutMs = 5000,
  step = 50
): Promise<HTMLElement | null> => {
  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms))
  const start = Date.now()
  let el: HTMLElement | null = document.getElementById(id)
  while (!el && Date.now() - start < timeoutMs) {
    await sleep(step)
    el = document.getElementById(id)
  }
  return el
}

export const handleKeyDown = (
  e: KeyboardEvent<HTMLDivElement>,
  onClose: () => void,
  dialogRef: RefObject<HTMLDivElement | null>
): void => {
  if (e.key === 'Escape') {
    e.stopPropagation()
    onClose()
  } else if (e.key === 'Tab') {
    // Trap focus inside dialog
    const container = dialogRef?.current
    if (!container) return
    const focusable = container.querySelectorAll<HTMLElement>(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable="true"]'
    )
    if (!focusable || focusable.length === 0) return
    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    // If focus isn't within the dialog, send it to the first element
    if (!container.contains(document.activeElement)) {
      first.focus()
      e.preventDefault()
      return
    }
    if (e.shiftKey) {
      if (document.activeElement === first) {
        last.focus()
        e.preventDefault()
      }
    } else {
      if (document.activeElement === last) {
        first.focus()
        e.preventDefault()
      }
    }
  }
}
